export default __webpack_public_path__ + "static/media/kg.2c09db55.svg";